import moment from 'moment-timezone'

const TIME_PERIOD_LABELS = {
  weekly: true,
  biweekly: true,
  monthly: true,
  '3 months': true,
  '6 months': true,
  '12 months': true
}

const TIME_PERIOD_TABLE = {
  weekly: {
    label: '1 week',
    period: 'DAYS',
    start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  },
  biweekly: {
    label: '2 weeks',
    period: 'DAYS',
    start: moment().subtract(14, 'days').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  },
  monthly: {
    label: '1 month',
    period: 'WEEKS',
    start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  },
  '3 months': {
    label: '3 months',
    period: 'WEEKS',
    start: moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  },
  '6 months': {
    label: '6 months',
    period: 'MONTHS',
    start: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  },
  '12 months': {
    label: '12 months',
    period: 'MONTHS',
    start: moment().subtract(1, 'years').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD')
  }
}

export function formatDate(date) {
  return moment(date).format('M/D/YYYY')
}

export function formatDay(date) {
  return moment(date).format('ddd')
}

export function formatJSDate(date) {
  return moment(date).toDate()
}

export function formatTime(date) {
  return moment(date).format('h:mm A')
}

export function formatTimestamp(date) {
  return moment(date).format('X')
}

export function formatDateTime(date) {
  return `${formatDate(date)} ${formatTime(date)}`
}

export function reportsTimePeriod({ duration }) {
  if (TIME_PERIOD_LABELS[duration]) {
    return TIME_PERIOD_TABLE[duration]
  }
  return null
}

export function fromNow(date) {
  return moment(date).fromNow()
}
